import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Modal, Input, InputNumber} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils"
import {uuid, validateName} from "../../../utils";

class AddRmGroupModal extends BaseComponent {

    static defaultProps = {
        fid: "",
        onOk: ()=>{}
    };

    state = {
        visible: false,
        addKey: uuid()
    };

    show(){
        this.setState({visible: true, addKey: uuid()});
    }

    hide(){
        this.setState({visible: false});
    }

    addRmGroup = ()=>{
        let name = this.input.input.value;
        let sort = this.inputNumber.inputNumberRef.input.value;
        if(!name){
            message.destroy();
            message.warn("请输入分组名称！");
            return;
        }
        if(!validateName(name,{min:1,max:8})){
            message.warn("分组名称只可填写中文、英文字母、数字及下划线，限制输入8个字符！")
            return;
        }
        let fid = this.props.fid;
        this.request({
            url: "/cm-sites-mmp/rm/group/add",
            body: { name, fid, sort },
            method: "post",
            contentType: "json",
            callBack:(res)=>{
                if(res) {
                    message.success("新增成功");
                    this.props.onOk();
                    this.hide();
                }
            }
        });
    };

    render() {
        return (
            <Modal
                visible={this.state.visible}
                title={"新增分组"}
                onCancel={()=>this.hide()}
                onOk={()=>this.addRmGroup()}
                width={480}
                key={this.state.addKey}
                maskClosable={false}
            >
                <table className={"group_table"} width={"100%"} border={0} cellSpacing={0} cellPadding={0}><tbody>
                    <tr>
                        <td width={85} align={"right"}><span style={{color: "red"}}>*</span>分组名称：</td>
                        <td><Input ref={input=>this.input = input} placeholder={"请输入分组名称"}/></td>
                    </tr>
                    <tr style={{height: 20, lineHeight: 20}}/>
                    <tr>
                        <td width={85} align={"right"}>排序：</td>
                        <td><InputNumber style={{width: 110}} ref={input=>this.inputNumber = input} placeholder={"请输入排序"}/></td>
                    </tr>
                </tbody></table>
                <style>{`.group_table tr + tr{margin: 20px;}`}</style>
            </Modal>
        );
    }
}

export default AddRmGroupModal;
